import { COLOR_TAGS_SEARCH_SCROLL_LOCALSTORAGE } from '../types';

export const setColorTagsSearchScrollLocalStorage = () => {
    localStorage.setItem(COLOR_TAGS_SEARCH_SCROLL_LOCALSTORAGE, '1');
}
